import React from "react";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import { makeStyles } from "@material-ui/core";
import OverflowTooltip from "../../../components/OverflowTooltip/OverflowTooltip";
import { Accordion, AccordionDetails, AccordionSummary } from "./Accordion";
import { ILanguageListItem } from "../types";
import { Course } from "./course/Course";
import { getBeautifiedCount } from "../../../helpers";

const useStyles = makeStyles(() => ({
  infoContainer: {
    display: "flex",
    alignItems: "center",
  },
  name: {
    maxWidth: 580,
    fontSize: 16,
    fontWeight: "bold",
    color: " #535358",
    paddingRight: 8,
  },
  courseCount: {
    fontSize: 14,
    color: "#828190",
  },
  accordionDetails: {
    width: "100%",
    "& > div": {
      marginBottom: 8,
    },
  },
}));

export const Language = ({ language }: { language: ILanguageListItem }) => {
  const classes = useStyles();

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ArrowRightIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <div className={classes.infoContainer}>
          <div className={classes.name}>
            <OverflowTooltip text={language.name} />
          </div>
          <div className={classes.courseCount}>
            {`(${getBeautifiedCount(language.courses.length, "course")})`}
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <div className={classes.accordionDetails}>
          {language.courses.map((course) => (
            <Course key={course.id} course={course} />
          ))}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};
